import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import CardiometabolicOverviewCombined from "./index";

const CardiometabolicOverviewWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={CardiometabolicOverviewCombined}
    keyControlsId="cardiometabolic-overview-key"
    {...props}
  />
);

export default CardiometabolicOverviewWithToggleKey;
